module.exports = __webpack_public_path__ + "static/media/services-icon-4.0b6e9a9a.svg";